import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
}

/**
 * SyntheticMonitorIcon component
 * Used for Synthetic Monitoring option in MonitorTypeSelector (matches HttpMonitorIcon / ScraperIcon pattern)
 */
export const SyntheticMonitorIcon: React.FC<IconProps> = ({
  size = 32,
  color = '#101018',
}) => {
  return (
    <svg
      width={size}
      height={size * (24 / 26)}
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.142 17.6429L9.28488 22.2857M14.8563 17.6429L16.7134 22.2857M7.42773 22.2857H18.5706M24.142 0.928589H1.85631C1.61003 0.928589 1.37385 1.02642 1.19971 1.20056C1.02557 1.3747 0.927734 1.61089 0.927734 1.85716V16.7143C0.927734 16.9606 1.02557 17.1968 1.19971 17.3709C1.37385 17.545 1.61003 17.6429 1.85631 17.6429H24.142C24.3883 17.6429 24.6245 17.545 24.7986 17.3709C24.9728 17.1968 25.0706 16.9606 25.0706 16.7143V1.85716C25.0706 1.61089 24.9728 1.3747 24.7986 1.20056C24.6245 1.02642 24.3883 0.928589 24.142 0.928589Z"
        stroke={color}
        strokeWidth="1.85714"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.35352 6.96347L5.10352 9.74918L7.88923 12.0706M18.1035 7.42775L20.8892 9.74918L17.6392 12.5349M11.6035 13.4635L14.3892 5.10632"
        stroke={color}
        strokeWidth="1.85714"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
